import React from "react";
import { BsDropletFill } from "react-icons/bs";

import SiteContainer from "../../../../../../components/SiteContainer";
import TopNavigation from "../template/TopNavigation";
import BottomNavigation from "../template/bottomNavigation";
import BottomSyncNavigation from "../template/bottomSyncNavigation";

interface PDALayoutTemplateProps {
  children: React.ReactNode;
  title: string;
  optionNumber?: number | string;
  pdaName?: string;
  pdaLink?: string;
  secondaryTitle?: string;
  secondaryLink?: string;
  icon?: React.ReactNode;
  prevNavigation?: {
    to: string;
    label: string;
  };
  nextNavigation?: {
    to: string;
    label: string;
  };
  hideNavigation?: boolean;
  navigating?: string | null;
  loading?: boolean;
  onNavigate?: (
    path: string
  ) => Promise<boolean | undefined | void> | (() => Promise<void> | void);
}

const PDALayoutTemplate: React.FC<PDALayoutTemplateProps> = ({
  children,
  title,
  optionNumber,
  pdaName,
  pdaLink,
  secondaryTitle,
  secondaryLink,
  icon,
  prevNavigation,
  nextNavigation,
  hideNavigation = false,
  navigating,
  loading = false,
  onNavigate,
}) => {
  // Handle navigation with path - calls onNavigate with the path, then navigates
  const handleNavigationWithSave = async (path: string) => {
    if (onNavigate) {
      try {
        await onNavigate(path);
      } catch (error) {
        console.error("Navigation save error:", error);
        return; // Don't navigate if save fails
      }
    }
    // Navigation is handled by the onNavigate function itself
  };

  return (
    <SiteContainer
      style={{ marginTop: "15px", fontFamily: "Work Sans", fontSize: "20px" }}
      className="px-10"
    >
      {pdaName && pdaLink && (
        <div
          style={{ marginBottom: "40px" }}
          className=" bg-blue-50 rounded-md border border-blue-200"
        >
          <TopNavigation
            pdaTitle={pdaName}
            pdaLink={pdaLink}
            secondaryTitle={secondaryTitle}
            secondaryLink={secondaryLink}
          />
        </div>
      )}

      <div className="mx-auto text-site-blue-dark">
        {optionNumber && (
          <div className="text-sm text-gray-600 font-bold ">
            Option {String(optionNumber)}
          </div>
        )}

        <div className="flex items-center gap-2">
          {icon && <div className="mb-[20px]">{icon}</div>}
          <h1
            className="text-left font-bold text-site-blue-dark mb-[20px]"
            style={{ fontSize: "36px", fontFamily: "Work Sans" }}
          >
            {title}
          </h1>
        </div>

        <div className="">{children} </div>
      </div>
      {(prevNavigation || nextNavigation) && !hideNavigation && (
        <div
          // style={{ marginTop: "40px", marginBottom: "20px" }}
          className="flex "
        >
          {onNavigate ? (
            // Use BottomSyncNavigation for components that need to save before navigation
            <BottomSyncNavigation
              prev={prevNavigation}
              next={nextNavigation}
              loading={loading || !!navigating}
              onNavigate={handleNavigationWithSave}
            />
          ) : (
            // Use regular BottomNavigation for simple navigation
            <BottomNavigation prev={prevNavigation} next={nextNavigation} />
          )}
        </div>
      )}
    </SiteContainer>
  );
};

export default PDALayoutTemplate;
